import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSession } from '@/lib/auth'
import { useAuthStore } from '@/stores/auth-store'

export function useAuth({ requireAdmin = true } = {}) {
  const { data: session, isPending } = useSession()
  const { setAuth, setLoading, clear } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (isPending) {
      setLoading(true)
      return
    }

    if (!session?.user) {
      clear()
      navigate('/login', { replace: true })
      return
    }

    const user = session.user as Record<string, unknown>

    if (requireAdmin && user.role !== 'admin') {
      clear()
      navigate('/unauthorized', { replace: true })
      return
    }

    setAuth(
      {
        id: session.user.id,
        email: session.user.email,
        name: session.user.name,
        firstName: user.firstName as string | undefined,
        lastName: user.lastName as string | undefined,
        avatarUrl: (user.avatarUrl ?? user.image) as string | undefined,
        role: user.role as string | undefined,
        twoFactorEnabled: user.twoFactorEnabled as boolean | undefined,
      },
      {
        id: session.session.id,
        expiresAt: String(session.session.expiresAt),
      }
    )
  }, [session, isPending, requireAdmin, navigate, setAuth, setLoading, clear])

  return useAuthStore()
}
